import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
declare var document: any;
@Injectable({
  providedIn: 'root',
})
export class LanguageSwitchService {
  private english: string = 'en';
  private arabic: string = 'ar';

  constructor(private translate: TranslateService) {}

  defaultLanguage() {
    if (!this.checkIfLanguageChoiceExists()) {
      this.translate.setDefaultLang(this.english);
      localStorage.setItem('language', this.english);
      if (document.getElementById('mainIndex')) {
      document.getElementById('mainIndex').setAttribute('lang', this.english);
      document.getElementById('mainBody').setAttribute('dir', 'ltr');
      }
    }
  }

  changeLanguage() {
    let lang = localStorage.getItem('language');
    if (lang === this.arabic) {
      this.translate.use(this.arabic);
      localStorage.setItem('language', this.arabic);
      if (document.getElementById('mainIndex')) {
        document.getElementById('mainIndex').setAttribute('lang', this.arabic);
        document.getElementById('mainBody').setAttribute('dir', 'rtl');
      }
    } else {
      this.translate.use(this.english);
      localStorage.setItem('language', this.english);
      if (document.getElementById('mainIndex')) {
        document.getElementById('mainIndex').setAttribute('lang', this.english);
        document.getElementById('mainBody').setAttribute('dir', 'ltr');
      }
    }
  }

  checkIfLanguageChoiceExists() {
    let lang = localStorage.getItem('language');
    if (lang === null) {
      return false;
    } else {
      this.translate.use(lang);
      localStorage.setItem('language', lang);
      const mainIndex = document.getElementById('mainIndex');
      if (mainIndex) {
        document.getElementById('mainIndex').setAttribute('lang', lang);
        if (lang == this.english) {
          document.getElementById('mainBody').setAttribute('dir', 'ltr');
        } else if (lang == this.arabic) {
          document.getElementById('mainBody').setAttribute('dir', 'rtl');
        }
        return true;
      }
      return false;
    }
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    sessionStorage.setItem('currentLanguage', lang);
    localStorage.setItem('curr_language', lang == 'ar' ? 'Arabic' : 'English');
    const mainIndex = document.getElementById('mainIndex');
    if (mainIndex) {
      document.getElementById('mainIndex').setAttribute('lang', lang);
      if (lang == this.english) {
        document.getElementById('mainBody').setAttribute('dir', 'ltr');
      } else if (lang == this.arabic) {
        document.getElementById('mainBody').setAttribute('dir', 'rtl');
      }
    }
  }

  getLanguage() {
    return localStorage.getItem('language');
  }
}
